module.exports = __webpack_public_path__ + "img/hero_sport_glide.30ce3b2c.jpg";